import { useContext, useEffect, useRef, useState } from 'react';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import Item from '../../../../components/Lists/Item';
import { NavBar } from '../../../../components/NavBar/NavBar';
import { SortingButton } from '../../../../components/Sorting/SortingButton';
import { SortingHeader } from '../../../../components/Sorting/SortingHeader';
import { SortingProvider } from '../../../../contexts/SortingContext';
import './VendorDiscrepancy.scss';
import Input from '../../../../components/Inputs/Input';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { useDispatch, useSelector } from 'react-redux';
import { Bold, Hlght } from '../VendorApproval/VendorApproval';
import Dropdowns from '../../../../components/Dropdowns/Dropdowns';
import { DropdownsProvider } from '../../../../contexts/DropdownsContext';
import Filters from '../../../../components/Filters/Filters';
import { FiltersManager } from '../../../../components/FiltersManager/FiltersManager';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import { DeleteAWB } from '../VendorAWB/DeleteAWB';
import { GeneralCard } from '../../../../components/Cards/GeneralCard';
import PackageWarning from '../../../../assets/Images/package-warning.png';
import { DialogContext } from '../../../../contexts/DialogContext';
import { DiscrepancyItemChatModal } from '../../../SupplyChainModules/Components/Discrepancy/DiscrepancyItemChatModal/DiscrepancyItemChatModal';
import { fetchDiscrepancies, fetchDiscrepancyTypes, selectDiscrepancyTypes, selectVendorDiscrepancies } from '../../../../redux/features/VendorModule/VendorDiscrepancy/VendorDiscrepancy';
import { getVendorDiscrepancies } from '../../Services/VendorDiscrepancyService';
import BasicDatePicker from '../../../../components/Datepicker/Datepicker';
import { connectSocket } from '../../../../Sockets/socketsConnection';

const mockDataDis = [
    { dicrepancyNumber: "3657952-1", status: "Pending Review", orderType: "PO", orderNumber: "1327898123123", LN: "2", location: "MIA", supplyChainUser: "Lorem Ipsum ", discrepancyUser: "Eric Haag" }
]


const StatusTag = (item, key) => {
    return (
         <button
          className={`ellipsis item-status-tag item-status-tag-${
            item[key] == "Pending Review"
              ? "orange"
              : item[key] == "Reviewed"
              ? "purple"
              : item[key] == "Confirmed"
              ? "green"
              : item[key] == "Resolution Provided"
              ? "blue"
              : item[key] == "Sent to Vendor"
              ? "orange"
              : "red"
          }`}
        >
          {item[key] || "--"}
        </button>
    )

}

const VendorDiscrepancy = ({ }) => {


    // const { successMsg } = useSnackBar();
    const [tempResolved, setTempResolved] = useState(false);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const discrepancies = useSelector(selectVendorDiscrepancies);
    const discrepancyTypes = useSelector(selectDiscrepancyTypes);
    const { openDialog, closeDialog } = useContext(DialogContext);
    const dispatch = useDispatch();
    const onFiltersChange = () => { };


    const openChatDialog = (discrId) => {
        openDialog({
            component: DiscrepancyItemChatModal,
            props: {
                onClose: closeDialog,
                discrepancyId: discrId,
                titleChat: "Supply Chain",
                channel: "vendor"
            },
        });
    };

    useEffect(() => {
        console.warn('useeffect');
        dispatch(fetchDiscrepancyTypes({}));
        dispatch(fetchDiscrepancies({ companyId: localStorage.getItem("u_company_id") }));
        connectSocket();
        // getVendorDiscrepancies(localStorage.getItem("u_company_id")).then(response => {
        //     console.warn('discrepancies response', response);
        // });
    }, [])



    return (
        <SortingContainer>
            <div className='vendor-discrepancy-component'>
                <NavBar dataBreadCrumbs="/vendor/discrepancy" moduleId={3} isLocalSearch searchActions={<><SortingButton></SortingButton>
                    <FiltersManager onButtonClick={() => setFiltersOpen((prev) => !prev)} />
                </>} />
                <div className='v-app-content'>
                    <Filters
                        extOpen={filtersOpen}
                        openChange={(value) => setFiltersOpen(value)}
                        onApplyFilters={onFiltersChange}
                        hideToggle
                        dropdownIds={[1, 2, 3]}
                        hideATA
                    />
                    {/* <div className='filters'>
                        <Dropdowns />
                    </div> */}
                    <SortingHeader></SortingHeader>
                    {/* {JSON.stringify(Object.keys(discrepancies[0] ?? {}))} */}
                    {discrepancies?.map((discr, idx) => {
                        // let discrType = "Hello World";
                        let discrType = discrepancyTypes?.[discr.discrepancyCategotyId]?.name;
                        return (<Expandable2 summary={<>

                            <Item valuePlaceholder="--" orderedProperties={[
                                "id",
                                "orderType",
                                "orderNumber",
                                "line",
                                "location",
                                "supplyChain",
                                "createdBy",
                                "status"
                            ]} lightFont hideLabels key={discr} item={discr}  renderProperty={{status: StatusTag}}>
                                {/* <Item renderProperty={{ "orderType": OrderType, "daysSince": Hlght }} ignoreProperties={["id", "status"]} lightFont hideLabels key={discr} item={discr}> */}

                            </Item></>}>
                            <div className='item-content'>
                                <GeneralCard title={
                                    <b>General Information</b>} >
                                    <div className='general-info-grid'>
                                        <Input label="Status" disabled value={discr.status || "--"} />
                                        <Input label="AWB" disabled value={discr.awbNumber || "--"} />
                                        <Input label="PN" disabled value={discr.discrenpancyPartNumber || "--"} />
                                        <Input label="PN Category" disabled value={discr.categoryName || "--"} />
                                        <Input label="PN Sub Category" disabled value={discr.subCategoryName || "--"} />
                                        <Input label="SN" disabled value={discr.serialNumber || "--"} />
                                        <Input label="Vendor Lot" disabled value={discr.vendorLot || "--"} />
                                        <Input label="Vendor Name" disabled value={"--" || "--"} />
                                        <Input label="UOM" disabled value={discr.uom || "--"} />
                                        <Input label="QTY" disabled value={discr.quantity || "--"} />
                                    </div>
                                </GeneralCard>
                                <GeneralCard title={
                                    <b>Discrepancy Information</b>} >
                                    <div className='discr-info-grid'>
                                        <Input label="Discrepancy Category" disabled value={discrType ?? "--"} />

                                        {(discrType == "Incorrect Quantity" || discrType == "Incorrect QTY") ? (
                                            <div className='subform'>
                                                <div>
                                                    <span>Requested QTY</span>
                                                    <Input label="" disabled value={discr.quantity} />

                                                </div>
                                                <div>
                                                    <span>Received QTY</span>
                                                    <Input label="" disabled value={discr.discrepancyQuantity} />
                                                </div>
                                                <div>
                                                    <span>UOM</span>
                                                    <Input label="" disabled value={discr.uom} />
                                                </div>
                                            </div>
                                        ) : discrType == "PN Does Not Exist" ? (
                                            <Input
                                                label={"Part Number (PN)"}
                                                value={discr.discrenpancyPartNumber ||"--"}
                                                disabled={true}
                                            ></Input>
                                        ) : discrType == "Expired Shelf Life" ? (
                                            <BasicDatePicker
                                                label={"Shelf Life"}
                                                name={"shelfLife"}
                                                value={discr.discrepancyShelfLife || "--"}
                                                disabled={true}
                                            ></BasicDatePicker>
                                        ) : discrType == "Wrong PN" ? (
                                            <Input
                                                label={"Part Number (PN)"}
                                                value={discr.discrenpancyPartNumber || "--"}
                                                disabled={true}
                                            ></Input>
                                        ) : <b></b>}
                                        <Input multiLine label="Reason Description" disabled value={discr.discrepancyDescription || "--"} />
                                    </div>
                                </GeneralCard>
                                <GeneralCard title={
                                    <div className='title-card'>

                                        <b className='panel-name'> {discr.status === "Resolution Provided" && <i className='icon-success'></i>}
                                            Discrepancy Resolution</b>
                                        <button className='filled iconButton blueButton' onClick={()=>openChatDialog(discr.id)}>
                                            <i className='icon-chat'></i>
                                            <span>
                                                Supply Chain
                                            </span>
                                            {false &&<span className='count'>
                                                10
                                            </span>}
                                        </button>
                                    </div>

                                } >
                                    {discr.status === "Resolution Provided" ? <div className='resolution'>
                                        {discr.resolution || "--"}

                                    </div> : <div className='resolution-placeholder'>
                                        <img src={PackageWarning}></img>
                                        {/* <b onClick={}>Discrepancy Pending Resolution</b> */}
                                        <b>Discrepancy Pending Resolution</b>
                                        <pre>
                                            The reported discrepancy has not been resolved.<br />
                                            Once a resolution is provided, it will be displayed here.<br />
                                            For follow-up or to propose a solution, please contact the <br /> Supply Chain team.
                                        </pre>

                                    </div>}

                                </GeneralCard>

                            </div>

                        </Expandable2>)
                    }

                    )}
                </div>

            </div>
        </SortingContainer >

    )

}

const SortingContainer = ({ children }) => {


    return (
        <SortingProvider properties={{
            "dicrepancyNumber": "Discrepancy Number",
            "orderType": "Order Type",
            "orderNumber": "Order Number",
            "LN": "LN",
            "location": "Location",
            "supplyChainUser": "Supply Chain User",
            "discrepancyUser": "Discrepancy User",
            "status": "Status",

        }}>
            {/* <DropdownsProvider> */}
            {children}
            {/* </DropdownsProvider> */}
        </SortingProvider>
    )

}
export default VendorDiscrepancy;